import React from 'react';
import { Outlet } from 'react-router-dom';

import Nav from '../Nav';

export default function SettingsPage() {
  return (
    <div id="settings" className="container">
      <div className="row">
        <div className="col-sm-12 col-md-3">
          <Nav />
        </div>
        <div className="col-sm-12 col-md-6 form-setting-container">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
